import React from 'react';
import IHeader from './IHeader';
import * as style from './HeaderStyle.module.scss'
const logo = require('./logo.png');

const Header: React.FunctionComponent<IHeader> = (props) => {
  const {} = props;

  return (
    <div>
      <img alt="BnkToTheFuture" src={logo} className={style.headerLogo} />
      <h1 className={style.headerText}>{props.text}</h1>
    </div>
  );
};

export default Header;
